<app-modal-wrapper
  [title]="tenantId ? 'Edit Tenant' : 'New Tenant'"
  [isDirty]="(tenantForm?.dirty ?? false) || !!selectedFile"
  [formValid]="tenantForm?.valid ?? false"
  [loading]="initialLoading"
  [showSaveButton]="true"
  [saveLoading]="submitting"
  [keepEditingLabel]="tenantId ? 'Keep editing' : 'Keep creating'"
  (save)="newOrSaveRecord()"
  (closeRequest)="ref.close()"
>
  <div modalSkeleton class="flex flex-col gap-6 pt-2">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
      <div class="col-span-12 md:col-span-7">
        <p-skeleton height="14px" width="60px" styleClass="mb-2"></p-skeleton>
        <p-skeleton height="38px" borderRadius="6px"></p-skeleton>
      </div>
      <div class="col-span-12 md:col-span-5">
        <p-skeleton height="14px" width="52px" styleClass="mb-2"></p-skeleton>
        <p-skeleton height="38px" borderRadius="6px"></p-skeleton>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
      <div class="col-span-12 md:col-span-5">
        <p-skeleton height="14px" width="78px" styleClass="mb-2"></p-skeleton>
        <p-skeleton height="38px" borderRadius="6px"></p-skeleton>
      </div>
      <div class="col-span-12 md:col-span-3">
        <p-skeleton height="14px" width="95px" styleClass="mb-2"></p-skeleton>
        <p-skeleton height="38px" borderRadius="6px"></p-skeleton>
      </div>
      <div class="col-span-12 md:col-span-4">
        <p-skeleton height="14px" width="55px" styleClass="mb-2"></p-skeleton>
        <p-skeleton height="38px" borderRadius="6px"></p-skeleton>
      </div>
    </div>

    <div class="flex flex-col gap-1">
      <p-skeleton height="14px" width="42px" styleClass="mb-2"></p-skeleton>
      <p-skeleton height="78px" borderRadius="8px"></p-skeleton>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
      <div class="col-span-12 md:col-span-8">
        <p-skeleton height="14px" width="105px" styleClass="mb-2"></p-skeleton>
        <p-skeleton height="38px" borderRadius="6px"></p-skeleton>
      </div>
      <div class="col-span-12 md:col-span-4">
        <p-skeleton height="14px" width="95px" styleClass="mb-2"></p-skeleton>
        <p-skeleton height="38px" borderRadius="6px"></p-skeleton>
      </div>
    </div>
  </div>

  <form #tenantForm="ngForm" class="flex flex-col gap-6">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
      <div class="col-span-12 md:col-span-7">
        <app-input-text
          label="Name"
          name="name"
          [(ngModel)]="model.name"
          placeholder="Ex: Company Name"
          [required]="true"
          required>
        </app-input-text>
      </div>
      <div class="col-span-12 md:col-span-5">
        <app-input-number
          label="CNPJ"
          name="cnpj"
          type="cnpj"
          [(ngModel)]="model.cnpj">
        </app-input-number>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-start">
      <div class="col-span-12 md:col-span-5">
        <app-input-text
          label="Subdomain"
          name="subdomain"
          [(ngModel)]="model.subdomain"
          placeholder="Ex: company"
          [required]="true"
          required>
        </app-input-text>
      </div>

      <div class="col-span-12 md:col-span-3 flex flex-col gap-1">
        <label
          class="font-bold text-gray-700 text-xs uppercase tracking-wide"
        >
          Primary Color <span class="text-red-500">*</span>
        </label>
        <div
          class="flex items-center h-[38px] w-full border border-gray-300 rounded-md overflow-hidden bg-white p-1"
        >
          <input
            type="color"
            name="primaryColor"
            [(ngModel)]="model.primaryColor"
            class="w-full h-full border-none p-0 cursor-pointer bg-transparent"
            required
          />
        </div>
      </div>

      <div class="col-span-12 md:col-span-4 flex flex-col gap-1 h-full">
        <label class="font-bold text-gray-700 text-xs uppercase tracking-wide"
          >Status</label
        >
        <div
          class="flex items-center gap-3 p-2 bg-gray-50 rounded-lg border border-gray-300 transition-all cursor-pointer group"
          (click)="activeInput.click()"
        >
          <div class="relative flex items-center justify-center w-5 h-5">
            <input
              #activeInput
              type="checkbox"
              name="active"
              [(ngModel)]="active"
              class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
              (click)="$event.stopPropagation()"
            />
            <i
              class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"
            ></i>
          </div>
          <label
            class="font-bold text-gray-700 text-sm select-none cursor-pointer"
          >
            Active
          </label>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-1">
      <label
        class="font-bold text-gray-700 text-xs uppercase tracking-wide mb-1"
      >
        Logo
      </label>
      <div
        class="flex items-center gap-2 bg-gray-50 p-4 rounded-lg border border-gray-300 border-dashed cursor-pointer hover:translate-y-[-3%] hover:bg-gray-100 transition-all duration-300"
        (click)="fileInput.click()"
      >
        <div class="flex-shrink-0">
          <button pButton type="button" icon="pi pi-paperclip"></button>
          <input
            #fileInput
            type="file"
            class="hidden"
            accept="image/png, image/jpeg, image/jpg"
            (change)="onFileSelected($event)"
          />
        </div>
        <div class="flex flex-col overflow-hidden">
          <span class="text-sm font-bold text-gray-700 truncate">
            {{
              selectedFile?.name || model.logoFileName || "No file selected"
            }}
          </span>

          <span
            *ngIf="model.logo && !selectedFile"
            class="text-xs text-green-600 font-medium"
          >
            <i class="pi pi-check-circle text-[10px]"></i> Current logo
            available
          </span>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
      <div class="col-span-12 flex flex-col gap-1">
        <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
          Bucket AWS URL
        </label>
        <div class="relative">
          <input
            pInputText
            type="text"
            name="bucketAws"
            [(ngModel)]="model.bucketAws"
            class="w-full text-sm pr-10"
            placeholder="s3://..."
          />
          <i
            class="pi pi-cloud absolute right-3 top-1/2 -translate-y-1/2 text-gray-400"
          ></i>
        </div>
      </div>
    </div>
  </form>
</app-modal-wrapper>
